import { render, staticRenderFns } from "./ldlePurchaseDetail.vue?vue&type=template&id=7137bf82&scoped=true"
import script from "./ldlePurchaseDetail.vue?vue&type=script&lang=js"
export * from "./ldlePurchaseDetail.vue?vue&type=script&lang=js"
import style0 from "./ldlePurchaseDetail.vue?vue&type=style&index=0&id=7137bf82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7137bf82",
  null
  
)

export default component.exports